import React, { Component } from "react";
import { ConnectionDialog } from "../../components";
// import { EditConnection } from "../../components";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// Externals
import PropTypes from "prop-types";
import classNames from "classnames";

// Material helpers
import { withStyles } from "@material-ui/core";

// Material components
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Tooltip from "@material-ui/core/Tooltip";

// Material Icons
import DoneIcon from "@material-ui/icons/Done";
import ClearIcon from "@material-ui/icons/Clear";

// Component styles
import styles from "./styles";
import {
  createConnector,
  createPublicRestConnector,
  setClickedConnector
} from "../../../../redux/actions/connectionActions";
import { removeMessage, pushMessage } from "../../../../redux/actions/commonActions";

import _ from "lodash";
import { openURLInNewWindow, connectorPlaceholderImage } from "../../../../common/utils";
import { buildBot } from "../../../../redux/actions/intentsActions";
import CardHeader from "@material-ui/core/CardHeader";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import DropDownMenu from "./dropDownMenu";
import { generatePublicChatbotSnippet } from "../../../../redux/actions/connectionActions";

import { FAQ_CONNECTION_NAMES } from "../../../../common/utils";

class ConnectionCard extends Component {
  state = {
    open: false,
    openEmbed: false,
    anchorEl: null,
    openMenu: false,
    customConnectors: ["servicenow-prod", "zendesk-prod", "Dynamics_365"],
    reloadAfterDisable: false,
    editableContent: null
  };

  handleCloseDialog = () => {
    this.setState({ open: false, editableContent: false });
  };

  handleOpenDialog = (connection = false) => {
    // openURLInNewWindow("http:///localhost:3000/connection-enabled");
    // var gettingCurrent = browser.tabs.getCurrent();
    // gettingCurrent.then(onGot, onError);
    if (this.props.administrator) {
      this.setState({ open: true });
      this.setState({ editableContent: _.get(connection, "connectionName", false) ? [connection] : false });
    }
  };

  handleEmbedDialog = state => {
    this.setState({ openEmbed: state });
  };

  handleOpen = () => {
    if (this.props.administrator) {
      if (this.props.connection.enabled) {
        this.props.pushMessage({
          message: "This connector is already enabled. To manage properties look under Enabled Connectors.",
          type: "info"
        });
        return;
      }

      this.props.setClickedConnector(this.props.connection);
      this.props.history.push("/enabled-intents/" + this.props.connection.compositeKey);
    }
  };

  handleConnect = initial => async (clientId, clientSecret, url) => {
    if (this.props.administrator) {
      if (this.props.connection.enabled) return;
      await this.props.createConnector(clientId, clientSecret, this.props.connection, url);

      if (this.props.enabledConnection) {
        localStorage.setItem("ConnectionId", this.props.connection.connectorName);
        localStorage.setItem("SkillId", this.props.skill.ID);
        // window.open(this.props.enabledConnection.oauthRedirectUrl, "_blank"); //to open new page
        // this.setState({ open: false });
        this.props.pushMessage({
          message: initial
            ? "Connector created successfully. You will be redirected shortly to link your account."
            : "Connector url successfully changed. You will be redirected shortly to link your account.",
          type: "success"
        });
        setTimeout(
          function() {
            openURLInNewWindow(this.props.enabledConnection.oauthRedirectUrl);
          }.bind(this),
          5000
        ); // wait 5 seconds
        setTimeout(
          function() {
            this.props.history.push("/enabled-intents/" + this.props.connection.connectionName);
          }.bind(this),
          4500
        ); // wait 4,5 seconds
        // await this.props.buildBot();
      } else {
        this.props.pushMessage({
          message: "Error during connection creating process. Try again or contact your administrator",
          type: "error"
        });

        setTimeout(
          function() {
            this.props.history.push("/enabled-intents/" + this.props.connection.connectionName);
          }.bind(this),
          4500
        ); // wait 4,5 seconds
      }
    }
  };

  handlePublicRestConnect = async (props, insert_edit) => {
    if (!props) {
      // Use data from the "template" connector for the new connector
      props = {
        faq_name: this.props.connection.connectionName,
        image: this.props.connection.image
      };
    }

    if (this.props.connection.enabled && insert_edit === "insert") return;

    let apiCallData = {
      action: insert_edit,
      template: this.props.connection,
      connectionName: props.faq_name,
      image: props.image
    };

    if (FAQ_CONNECTION_NAMES.includes(this.props.connection.connectionName)) {
      await this.props.generatePublicChatbotSnippet();
      apiCallData.collection_name = this.props.connections.publicChatbotProps.data.GUID;
    }

    if (
      props.hasOwnProperty("fallbackIntentPlainTextResponse") &&
      props.hasOwnProperty("fallbackIntentRichCardResponse")
    ) {
      apiCallData.fallbackIntentPlainTextResponse = props.fallbackIntentPlainTextResponse;
      apiCallData.fallbackIntentRichCardResponse = props.fallbackIntentRichCardResponse;
      apiCallData.fallbackIntentId = props.fallbackIntentId;
    }

    await this.props.createPublicRestConnector(apiCallData);
    if (this.props.enabledConnection && insert_edit === "insert") {
      this.props.pushMessage({
        message: "Connector created successfully. You will be redirected shortly to enable this connector.",
        type: "success"
      });
      setTimeout(
        function() {
          this.props.history.push("/enabled-intents/" + this.props.connection.connectionName);
        }.bind(this),
        4500
      ); // wait 4,5 seconds
    } else if (this.props.enabledConnection && insert_edit === "edit") {
      this.props.pushMessage({
        message: "Connector created edited.",
        type: "success"
      });
    } else {
      this.props.pushMessage({
        message: "Error during connection creating process. Try again or contact your administrator",
        type: "error"
      });
    }
  };

  getConnectorImage = connector => {
    const connectorImage = connector.image;

    if (connectorImage) {
      return connectorImage;
    }

    return connectorPlaceholderImage;
  };

  handleOpenMenu = event => {
    if (this.props.administrator) {
      event.stopPropagation();
      this.setState({ anchorEl: event.currentTarget });
    }
  };

  handleCloseMenu = () => {
    if (this.props.administrator) {
      this.setState({ anchorEl: null });
    }
  };

  showConnectionDetailsDialog = initial => {
    return (
      <ConnectionDialog
        connection={this.props.connection}
        open={this.state.open}
        handleClose={this.handleCloseDialog}
        handleConnect={this.handleConnect(initial === true ? initial : false)}
        customConnectors={this.state.customConnectors}
        handlePublicRestConnect={this.handlePublicRestConnect}
        editableContent={this.props.editable ? this.props.editable : this.state.editableContent}
      />
    );
  };

  /**
   * Show info about tasks (e.g. number of tasks) for all connection cards except for the card used to setup the
   * fallback intent.
   */
  renderTasksInfo = (connectionName, textualContent, classes) => {
    if (connectionName === "fallback-intent-setup") {
      return null;
    }

    return (
      <Typography variant="body1" color="textSecondary" className={classes.connectorTasks}>
        {textualContent}
      </Typography>
    );
  };

  render() {
    const { classes, className, connection } = this.props;

    let taskTotal =
      connection["intents"] && connection.intents.length > 1
        ? connection.intents.filter(intent => !_.get(intent, "deleted", false)).length + " Tasks"
        : connection.intents.length === 1
        ? "1 Task"
        : "No Tasks";
    const backgroundClass =
      connection.enabled || !this.props.administrator
        ? classNames(classes.cardEnabled, className)
        : classNames(classes.card, className);

    if (["faq-dev", "faq"].indexOf(connection.connectionName) >= 0) {
      taskTotal = "1 Task";
    }

    let displayLink =
      (this.props.connection.hasOwnProperty("auth_exists") && this.props.connection.auth_exists) ||
      this.props.connection.type === "public-rest-api"
        ? false
        : this.props.connection.hasOwnProperty("auth_exists");

    if (
      this.props.showBadge &&
      _.get(this.props, "connection.enabled", this.props.connection.hasOwnProperty("auth_exists"))
    ) {
      return (
        <React.Fragment>
          {this.state.anchorEl && (
            <DropDownMenu
              anchorEl={this.state.anchorEl}
              handleCloseMenu={this.handleCloseMenu}
              handleOpenDialog={this.handleOpenDialog}
              showConnectionDetailsDialog={this.showConnectionDetailsDialog}
              currentConnection={connection}
              open={this.state.open}
              customConnectors={this.state.customConnectors}
              displayLink={displayLink} // Show Link btn in dropdown
              // connectorName=connection.connectorName}

              // reloadAfterDisable={this.reloadAfterDisable}
            />
          )}
          <Badge
            badgeContent={
              (this.props.connection.hasOwnProperty("auth_exists") && this.props.connection.auth_exists) ||
              this.props.connection.type === "public-rest-api" ? (
                <Tooltip title="Connected" placement="right">
                  <DoneIcon />
                </Tooltip>
              ) : this.props.connection.hasOwnProperty("auth_exists") ? (
                <Tooltip title="Not Connected" placement="right">
                  <ClearIcon />
                </Tooltip>
              ) : (
                <span />
              )
            }
            classes={{
              badge:
                (this.props.connection.hasOwnProperty("auth_exists") && this.props.connection.auth_exists) ||
                this.props.connection.type === "public-rest-api"
                  ? classes.badgeSuccess
                  : classes.badgeError
            }}
          >
            <Card className={backgroundClass} onClick={this.handleOpen}>
              <CardMedia
                className={classes.cover}
                // image={this.getConnectorImage(connection)}
                title={connection.connectorName}
                // image={this.getConnectorImage(connection)}
              >
                <img src={this.getConnectorImage(connection)} className={classes.cardImage} />
              </CardMedia>

              <div className={classes.details}>
                <CardContent className={classes.content}>
                  <Typography component="h4" variant="h5" className={classes.connectorTitle}>
                    {_.get(connection, "display_name", _.get(connection, "connectorName", ""))}
                  </Typography>
                  <Typography variant="body1" color="textSecondary" className={classes.connectorTasks}>
                    {taskTotal}
                  </Typography>
                </CardContent>
              </div>

              <div className={classes.grower} />

              <CardHeader
                className={classes.cardHeader}
                action={
                  <IconButton aria-label="settings" className={classes.moreButton} onClick={this.handleOpenMenu}>
                    <MoreVertIcon />
                  </IconButton>
                }
              />

              <div className={classes.cardContainer} />
            </Card>
          </Badge>
        </React.Fragment>
      );
    } else {
      return (
        <div>
          {/*<Card className={backgroundClass} onClick={this.handleConnect}>*/}
          <Card className={backgroundClass} onClick={this.handleOpenDialog}>
            <CardMedia
              className={classes.cover}
              // image={this.getConnectorImage(connection)}
              title={connection.connectorName}
            >
              <img src={this.getConnectorImage(connection)} className={classes.cardImage} />
            </CardMedia>
            <div className={classes.details}>
              <CardContent className={classes.content}>
                <Typography component="h4" variant="h5" className={classes.connectorTitle}>
                  {connection.connectorName}
                </Typography>
                {this.renderTasksInfo(connection.connectionName, taskTotal, classes)}
              </CardContent>
            </div>
          </Card>
          {this.showConnectionDetailsDialog(true)}
        </div>
      );
    }

    return (
      <div>
        <Card className={backgroundClass} onClick={this.handleOpen}>
          <CardMedia
            className={classes.cover}
            // image={this.getConnectorImage(connection)}
            title={connection.connectorName}
          >
            <img src={this.getConnectorImage(connection)} className={classes.cardImage} />
          </CardMedia>
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography component="h4" variant="h5" className={classes.connectorTitle}>
                {connection.connectorName}
              </Typography>
              <Typography variant="body1" color="textSecondary" className={classes.connectorTasks}>
                {taskTotal}
              </Typography>
            </CardContent>
          </div>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    connectorName: state.connectorName,
    skill: state.skill,
    connections: state.connections,
    enabledConnection: state.connections ? state.connections.enabledConnection : "",
    message: state.common.message,
    administrator: _.get(state.auth.cognitoUser.attributes, "custom:role", "user") === "Administrator"
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        createConnector,
        createPublicRestConnector,
        generatePublicChatbotSnippet,
        removeMessage,
        pushMessage,
        setClickedConnector,
        buildBot
      },
      dispatch
    ),
    dispatch
  };
}

ConnectionCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  connection: PropTypes.object.isRequired,
  createConnector: PropTypes.func,
  history: PropTypes.object.isRequired,
  showBadge: PropTypes.bool
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(ConnectionCard))
);
